import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

interface UploadChannelParams {
    customer: string;
    lob: string;
    user_id: string;
    date: string;
    channel: string;
    file?: File;
}

@injectable()
export class UploadChannelUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (params: UploadChannelParams): Promise<any> => {
        return await this._aiRepository.uploadChannel(params);
    }
}

export const UploadChannelUseCaseName = "UploadChannelUseCaseName";

